module.exports = ":host{\r\n    width: 100% ;\r\n    flex-shrink: 0;\r\n}\r\n.tab-slide{\r\n    overflow: hidden;\r\n    min-height: 600px;\r\n}"